import moment from 'moment'
import { ReactElement } from 'react'
import { DisplayProviderAvatar } from './DisplayProviderAvatar'
import { AppointmentTypeType } from 'app/models/AppointmentType'
import { ProviderType } from 'app/models/Provider'

export function AppointmentDetails({
  apptType,
  selectedDay,
  provider,
  selectedTime,
}: {
  apptType: AppointmentTypeType
  selectedDay: string
  provider: ProviderType
  selectedTime: string
}): ReactElement {
  return (
    <div className="w-full rounded-lg bg-trn-100 p-4">
      <div className="mb-1 hidden text-heading-sm text-neutral-900 md:flex">
        {apptType.alias ?? apptType.displayName}
      </div>
      {/* Desktop */}
      <div className="mt-1 hidden items-center gap-x-2 text-sm font-medium text-neutral-500 md:flex">
        <div className="h-5 w-5 shrink-0">
          <DisplayProviderAvatar provider={provider} />
        </div>
        <span className="text-balance">{`${provider.displayName} · ${moment(selectedDay).format(
          `dddd, MMMM D`,
        )} at ${selectedTime}`}</span>
      </div>
      {/* Mobile */}
      <div className="flex items-center gap-2 md:hidden">
        <div className="h-16 w-16 shrink-0">
          <DisplayProviderAvatar provider={provider} fontSize="20" />
        </div>
        <div className="flex flex-col text-heading-sm text-neutral-900">
          {apptType.alias ?? apptType.displayName}
          <span className="text-balance  text-sm font-medium text-neutral-500">{`${provider.displayName} · ${moment(
            selectedDay,
          ).format(`dddd, MMMM D`)} at ${selectedTime}`}</span>
        </div>
      </div>
    </div>
  )
}
